module.exports = __webpack_public_path__ + "static/media/Ultimopedido2.a252327d.png";